import { Button } from '@/components/ui/button';
import { useAuthDialog } from '@/context/auth-dialog.context';

export function AuthDialogTrigger() {
  const { openDialog } = useAuthDialog();

  return (
    <Button variant="secondary" onClick={openDialog}>
      Войти
    </Button>
  );
}
